/* eslint-disable react/sort-comp */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { LaunchDarklyClient } from 'li-feature-flags'

import config from '../config'
import { isFullyAuthenticated, getAppDotOrigin } from '../util'
import { actions, alert } from '../lib'
import LoginFooter from './LoginFooter'
import RightsAgreement from './RightsAgreement'
import MarketingPanel from './MarketingPanel'
import Info from './Info'
import { Input, FormGroup, Label, SubmitButton } from './styled'

const mapStateToProps = state => ({
  loginData: state.auth.loginData,
  isInternal: state.appShellUi.isInternal,
  internalDisplayName: state.appShellUi.internalDisplayName,
})

const mapDispatchToProps = dispatch => ({
  authLogin: (email, password, agreement) =>
    dispatch(actions.authLogin({ email, password, agreement })),
  authUser: () => dispatch(actions.authUser()),
  killAlert: () => dispatch(alert({ show: false })),
})

export class Login extends Component {
  static contextTypes = {
    onFullyAuthenticated: PropTypes.func.isRequired,
    router: PropTypes.object.isRequired,
    appId: PropTypes.string.isRequired,
    useRelativePasswordResetLink: PropTypes.bool.isRequired,
  }

  static propTypes = {
    loginData: PropTypes.object.isRequired,
    isInternal: PropTypes.bool.isRequired,
    internalDisplayName: PropTypes.string,
    location: PropTypes.object,
    authLogin: PropTypes.func.isRequired,
    authUser: PropTypes.func.isRequired,
    killAlert: PropTypes.func.isRequired,
  }

  state = {
    showRightsAgreement: false,
    agreement: false,
    loginMessage: '',
  }

  componentDidMount() {
    this.getStatusMessage()
  }

  componentWillUnmount() {
    this.props.killAlert()
  }

  async getStatusMessage() {
    try {
      const client = await new LaunchDarklyClient(
        config.launchDarklyKey
      ).getClient()

      const loginMessage = await client.variation('admin-login-message')

      if (loginMessage && loginMessage !== 'off') {
        this.setState({ loginMessage })
      }
    } catch (ignore) {
      //
    }
  }

  submit = async e => {
    if (e) e.preventDefault()

    const { email, password } = this.getInputValues()
    const { authLogin, authUser, location } = this.props
    const { redirectPath = '/' } = location.query

    try {
      await authLogin(email, password, this.state.agreement)

      if (!this.props.loginData.fullyAuthenticated) {
        this.handleAdditionalLoginRequirements()
      } else {
        await authUser()
        if (isFullyAuthenticated()) {
          this.context.onFullyAuthenticated(this.context.router, redirectPath)
        } else {
          this.context.router.push('/verify-email')
        }
      }
    } catch (err) {
      console.error('Login#submit >> err:', err)
    }
  }

  handleAdditionalLoginRequirements() {
    const { loginData, location } = this.props
    const { redirectPath = '/' } = location.query

    if (loginData.requiresPasswordReset) {
      this.context.router.push(`/reset-password?redirectPath=${redirectPath}`)
    } else if (loginData.requiresRightsAgreement) {
      this.setState({ showRightsAgreement: true })
    } else if (loginData.requiresSecondFactor) {
      this.context.router.push(`/second-factor?redirectPath=${redirectPath}`)
    }
  }

  gotoPasswordReset(redirectPath = '/') {
    const pathname = `/reset-password?redirectPath=${redirectPath}`

    if (this.context.useRelativePasswordResetLink) {
      this.context.router.push(pathname)
    } else {
      global.location.href = getAppDotOrigin() + pathname
    }
  }

  getInputValues() {
    return {
      email: (this.email.value || '').trim(),
      password: (this.password.value || '').trim(),
    }
  }

  onAgree = () => {
    this.setState(
      {
        showRightsAgreement: false,
        agreement: true,
      },
      this.submit
    )
  }

  onDecline = () => {
    this.setState({
      showRightsAgreement: false,
      agreement: false,
    })
  }

  getTitle = () => {
    const { isInternal, internalDisplayName } = this.props

    const destination = isInternal
      ? internalDisplayName || this.context.appId
      : 'Label Insight'

    return `Log in to ${destination}`
  }

  render() {
    const { showRightsAgreement, loginMessage } = this.state

    return (
      <div className="Login">
        {loginMessage && (
          <Info>
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: loginMessage }}
            />
          </Info>
        )}
        <MarketingPanel title={this.getTitle()}>
          <RightsAgreement
            show={showRightsAgreement}
            onAgree={this.onAgree}
            onDecline={this.onDecline}
          />
          <main>
            <form name="loginForm" onSubmit={this.submit}>
              <FormGroup>
                <Label htmlFor="userEmail">Email</Label>
                <Input
                  type="email"
                  name="userEmail"
                  id="userEmail"
                  required
                  innerRef={x => (this.email = x)}
                />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="userPassword">Password</Label>
                <Input
                  type="password"
                  name="userPassword"
                  required
                  innerRef={x => (this.password = x)}
                />
              </FormGroup>
              <FormGroup>
                <SubmitButton value="Log In" size="large" />
              </FormGroup>
            </form>
          </main>
          <LoginFooter />
        </MarketingPanel>
        <h1 style={{ textAlign: 'center', color: 'white' }}>
          {this.context.appId}
        </h1>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/components/Login.js